import React, { Component, PureComponent } from "react";
import cx from "classnames";
import _debounce from "lodash/debounce";
//

class Autocomplete extends Component {
  state = {
    value: ""
  };

  constructor(props) {
    super(props);
    this.debouncedOnInput = _debounce(props.onInput, 500);
  }

  _onInput = ev => {
    const value = ev.target.value;

    this.setState({ value });

    this.debouncedOnInput(value);
  };

  _onSelect = (id, name) => {
    this.setState({ value: name });
    this.props.onSelect(id);
  };

  render() {
    const { placeholder, items, className, value } = this.props;

    return (
      <div className={cx("autocomplete", className)}>
        <div className="form__field">
          <input
            autoFocus
            type="text"
            placeholder={placeholder}
            value={value || this.state.value}
            className="form__control"
            onChange={this._onInput}
          />
        </div>
        {Boolean(this.state.value) &&
          items.length > 0 && (
            <ol className="autocomplete__items o-list-bare">
              {items.map(item => (
                <AutocompleteItem
                  key={item.id}
                  id={item.id}
                  name={item.name}
                  onClick={this._onSelect}
                />
              ))}
            </ol>
          )}
      </div>
    );
  }
}

class AutocompleteItem extends PureComponent {
  _onClick = ev => {
    const { id, name } = this.props;
    this.props.onClick(id, name);
  };

  render() {
    const { id, name } = this.props;

    return (
      <li key={id} className="autocomplete__item" onClick={this._onClick}>
        {name}
      </li>
    );
  }
}

export default Autocomplete;
